import React from 'react';

const PsanckPromo = () => {
  return (
  <object data="./Psanck_press_release.pdf" type="application/pdf" width="100%" height="100%"></object>
  )
}

export { PsanckPromo }
